import { connect } from 'react-redux';
import React from 'react';
import { KBForm, KBButton, KBAsyncInputList } from 'components';
import { api } from 'app/services';
import { CONTACTS_IDCARD_TYPE } from 'app/constants';
import { getEntitiesJsonArray } from 'app/reducers/reducer_utils';
import { reduxForm } from 'redux-form';
import { withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';

var OrgOpportunityForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.getOpportunitiesOfQuery = this.getOpportunitiesOfQuery.bind(this);this.saveOrgOppOfNext = this.saveOrgOppOfNext.bind(this);this.saveOrgOppOfComplete = this.saveOrgOppOfComplete.bind(this);this.saveOrgOppOfUpdate = this.saveOrgOppOfUpdate.bind(this);this.saveOrgOppOfLast = this.saveOrgOppOfLast.bind(this);}getInitialState()
  {
    return {
      formSubmitting: this.props.formSubmitting };

  }componentDidMount() {
    const {
      source,
      urlParams,
      fields: { opportunity_id } } =
    this.props;
    if (source === 'crm' && urlParams && urlParams.opportunity_id) {
      opportunity_id.onChange(urlParams.opportunity_id);
    }
  }componentDidUpdate(prevProps) {
    if (this.props.formSubmitting !== prevProps.formSubmitting) {
      this.setState({
        formSubmitting: this.props.formSubmitting });

    }
  }getOpportunitiesOfQuery(

  str, callback) {
    api.getOpportunities({ query: str, state: 'success' }).then(json => {
      const opportunities = getEntitiesJsonArray(json, 'opportunities');
      callback && callback(opportunities);
    });
  }saveOrgOppOfNext(

  model) {
    const { saveParams } = this.props;
    const { formSubmitting } = this.state;
    !formSubmitting && saveParams && saveParams(model, 5);
  }saveOrgOppOfComplete()

  {
    const { saveParams } = this.props;
    const { formSubmitting } = this.state;
    !formSubmitting && saveParams && saveParams({}, 5);
  }saveOrgOppOfUpdate(

  model) {
    const { saveParams } = this.props;
    return saveParams && saveParams(model, false, true);
  }saveOrgOppOfLast()

  {
    const { fields, saveParams } = this.props;
    let model = {};
    Object.keys(fields).map(field_key => {
      model[field_key] = fields[field_key].value;
    });
    saveParams && saveParams(model, 3);
  }render()

  {
    const {
      fields: { opportunity_id },
      handleSubmit,
      opp_title,
      urlParams,
      isUpdate } =
    this.props;
    const { formSubmitting } = this.state;

    return (
      <KBForm type="reduxForm">
        <header className="kb-form-header">
          <h2 className="header-title">客户信息</h2>
        </header>
        <div className="kb-form-container">
          <div className="kb-row kb-form-84">
            <KBAsyncInputList
            showImg={false}
            param={{ name: 'title', user: 'customer' }}
            field={opportunity_id}
            defaultValue={
            isUpdate ? opp_title || '' : urlParams.opp_name || ''}

            multi={false}
            className="kb-form-group kb-form-c18 kb-form-alone"
            hint="请输入客户名称来搜索并关联客户"
            title="客户"
            isTextOver={false}
            getData={this.getOpportunitiesOfQuery} />

            <div />
          </div>
          <div className="kb-row">
            <KBButton
            className="certain-btn"
            type="button"
            onClick={this.saveOrgOppOfLast}
            style={{ marginRight: 30 }}>

              上一步
            </KBButton>
            <KBButton
            className="certain-btn"
            type="submit"
            onClick={handleSubmit(this.saveOrgOppOfNext)}
            style={{ marginRight: 30 }}>

              下一步
            </KBButton>
            {!isUpdate ?
            <KBButton
            className="certain-btn"
            onClick={this.saveOrgOppOfComplete}>

                不关联客户
              </KBButton> :

            <KBButton
            className="certain-btn"
            type="submit"
            onClick={handleSubmit(this.saveOrgOppOfUpdate)}
            submitting={formSubmitting}>

                完成编辑
              </KBButton>}

          </div>
        </div>
      </KBForm>);

  }};


function mapStateToProps(state, props) {
  const { org, urlParams } = props;
  const isUpdate = urlParams && urlParams.type === 'update' && org;
  const opp_title =
  org &&
  org.opportunities &&
  org.opportunities[0] &&
  org.opportunities[0].title;

  return {
    isUpdate,
    opp_title,
    initialValues: org ?
    {
      ...org } :

    {} };

}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "opportunity_id"
];

const formConfig = {
  form: 'OrgOpportunityForm',
  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('OrgOpportunityForm', LEGACY_FORM_FIELDS)(OrgOpportunityForm)));
